import React from "react";
import AdultContentIconSVG from "assets/svg/adult-content-icon";
import VerifyIconXSVG from "assets/svg/verified-icon-xs";
import UsersIconSVG from "assets/svg/users";
import EditIconSVG from "assets/svg/edit-icon";
import { AiFillDelete } from "react-icons/ai";
import ProfileDefault from "assets/images/profile_default.png";
import { listFormat, capitalizeWords, currentLang } from "utils/utils";
import _ from "lodash";

import UpgradePremium from "components/subscription/upgrade-premium";
import LockOutlineIcon from "assets/svg/upgrade/lock-outline-icon"
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


export default function HeaderProfileList({
  userData,
  profiles = [],
  hideTitle = false,
  editable = false,
  border = false,
  isSubscribed = false,
  onEdit = () => { },
  switchProfile = () => { },
  visitProfile = () => { },
  deletable=false,
  onDelete = ()=>{}
}) {
  const lang = currentLang()
  const {t} = useTranslation();
  const onClickSwitch = (obj) => {
    if (obj.id !== userData?.profile?.id) {
      switchProfile(obj);
    } else {
      visitProfile(obj)
    }
  };

  const verfiedFullName = (data)=>{
    if(data.profile_name === `${data?.first_name} ${data?.first_last}`){
      return true;
    }else{
      return false;
    }
  }

  const occupation = (occupations,obj) => {
      const {translation_occupation = null} = obj || {}
      if (occupations) {
        var capitalizedArray = occupations.map(capitalizeWords);
        const list = capitalizedArray.map((o) => {
          if (typeof o === "object") {
            return translation_occupation?.[lang]?.[o.value] || o.value;
          } else if (typeof o === "string") {
            return translation_occupation?.[lang]?.[o] || o;
          } else {
            return null;
          }
        });
  
        if (list) {
          const currLang = lang === 'ch' ? 'zh-cn' : lang;
          if(currLang !== 'undefined') { 
            return listFormat(list,currLang);
          }else{
            return listFormat(list,'en');
          }
        }
      }
      return "";
    }

  return (
    <div className="w-full">
      {(!userData?.profile?.id3_verified && isSubscribed) && (
        <div className="flex flex-row items-center justify-center px-8 py-3 space-x-2 bg-lightBlack text-white">
          <VerifyIconXSVG />
          <span className="text-sm text-white font-semibold leading-5.5">
            Get your Verified Badge by <Link to="/verify-account" className="underline cursor-pointer">clicking here</Link>
          </span>
        </div>
      )}

      {(!hideTitle && profiles.length > 1) && (
        <div className="flex flex-row items-center px-8 pt-4.5 pb-2.5 space-x-2">
          {!isSubscribed && <LockOutlineIcon />}
          <h1 className="text-lg text-lightBlack font-bold leading-5.5 tracking-tighter">
            {t('myProfiles')} ({profiles.length}/5)
          </h1>
        </div>
      )}
      {isSubscribed ?
        <div className="w-full">
          {profiles.length > 1 && profiles.map((obj, index) => {
            const showAdult = obj.show_adult ? true : false;
            const occupations = occupation(obj.occupations, obj);
            const {translation = null} = obj || {}

            return (
              <div
                key={index}
                className={`w-full px-6 py-3 ${obj.id === userData?.profile?.id ? "bg-profileGray" : ""} ${border ? "border-b border-profileGray" : ""
                  }`}
              >
                <div
                  className={`w-full cursor-pointer ${editable
                    ? "flex 2sm:justify-between 2sm:items-center"
                    : ""
                    }`}
                  onClick={() => onClickSwitch(obj)}
                >
                  <div className="w-full flex items-center gap-x-5">
                    <div className="w-15 h-15 bg-passwordGray rounded-md min-width-12-p">
                      <img
                        src={obj?.profile_image_webp_url || obj.profile_image_url || ProfileDefault}
                        alt="milestone-profile"
                        className="rounded-md w-15 h-15"
                      />
                    </div>
                    <div className="w-[225px] 2sm:w-full">
                      <div className="w-full 2xs:flex 2xs:items-center 2xs:space-x-2">
                        <p className="text-lightBlack font-bold text-lg leading-5.5 tracking-tighter flex items-center">
                          {/* {userData?.profile?.username || obj?.other_name || userData?.user?.username} */}
                          <> {translation?.[lang]?.[obj?.profile_name] || obj?.profile_name || 
                              translation?.[lang]?.[obj?.other_name] || obj?.other_name || 
                              userData?.user?.username
                              }</>
                          {obj?.id3_verified && (
                            <VerifyIconXSVG className="ml-2" />
                          )}
                        </p>
                        {/* {showAdult && (
                          <div className="flex items-center ">
                            <AdultContentIconSVG className="mr-2" />
                            <p className="font-bold text-sm leading-6 text-pink">
                              {t('adultContent')}
                            </p>
                          </div>
                        )} */}
                      </div>
                      <div className="w-full 5sm:flex 5sm:items-center 5sm:space-x-2">
                        {occupations && (
                          <>
                            <div className="profile-occupations text-darkerGray text-xs leading-4.5 w-full">
                              {occupations}
                            </div>
                            {/* <p className="hidden 5sm:block text-sm text-passwordGray">
                              &#x2022;
                            </p> */}
                          </>
                        )}
                      </div>
                      { (obj?.display_count) > 0 &&
                        <div>
                          <p className="text-darkerGray text-xs leading-4.5 flex items-center">
                            <UsersIconSVG className="mr-2" />
                            <>{(obj?.display_count) || 0} {(obj?.display_count) > 1 ? "Users" : t('users')}</>
                          </p>
                        </div>
                      }
                    </div>
                  </div>
                  {(deletable && userData?.profile?.id !== obj.id) && (
                    <button
                      className="2sm:pl-2 py-2 2sm:ml-18 2sm:ml-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(obj);
                      }}
                    >
                      <AiFillDelete className="text-2xl text-red  mr-3 md:mr-2 cursor-pointer hover:text-3xl"/>
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        : <UpgradePremium customHeadline="Add and Manage Profiles - Upgrade to Unlock" customText="Upgrade so you can create up to four additional profiles (groups, teams, characters or businesses) and access advanced profile management"/>
      }
    </div>
  );
}
